export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";